module.exports = __webpack_public_path__ + "img/3.650b96d0.png";